import {
  Box,
  Text,
  OrderedList,
  UnorderedList,
  ListItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td
} from '@chakra-ui/react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { omit } from 'lodash';

export const MessageContent = ({ content }) => (
  <Box>
    <Markdown
      remarkPlugins={[remarkGfm]}
      style={{ letterSpacing: 'wide', color: 'surface.onSurfaceVariant' }}
      components={{
        table: ChakraTable,
        thead: Thead,
        tbody: Tbody,
        tr: Tr,
        th: Th,
        td: Td,
        h1,
        h2,
        h3,
        p,
        ol,
        ul,
        li,
        strong
      }}
    >
      {content?.trim()}
    </Markdown>
  </Box>
);

const h1 = (props) => (
  <Text
    as='h1'
    mb={4}
    lineHeight='1.6'
    {...omit(props, 'node')}
  >
    {props.children}
  </Text>
);

const h2 = (props) => (
  <Text
    as='h2'
    mb={4}
    lineHeight='1.6'
    {...omit(props, 'node')}
  >
    {props.children}
  </Text>
);

const h3 = (props) => (
  <Text
    as='h3'
    mb={4}
    lineHeight='1.6'
    {...omit(props, 'node')}
  >
    {props.children}
  </Text>
);

const p = (props) => (
  <Text
    as='p'
    mb={4}
    lineHeight='1.6'
    {...omit(props, 'node')}
  >
    {props.children}
  </Text>
);

const ol = (props) => (
  <OrderedList
    spacing={2}
    ml={4}
    mb={4}
    {...omit(props, 'node')}
  >
    {props.children}
  </OrderedList>
);

const ul = (props) => (
  <UnorderedList
    spacing={2}
    ml={4}
    mb={4}
    {...omit(props, 'node')}
  >
    {props.children}
  </UnorderedList>
);

const li = (props) => (
  <ListItem
    mb={2}
    {...omit(props, 'node')}
  >
    {props.children}
  </ListItem>
);

const strong = (props) => (
  <Text
    as='span'
    color='brandPrimary.primary'
    fontWeight={600}
    {...omit(props, 'node')}
  />
);

const ChakraTable = ({ children }) => (
  <Table
    size='sm'
    variant='simple'
    my={4}
  >
    {children}
  </Table>
);

export default MessageContent;
